import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { apiConstant } from '../app.constant';
import {
    AgencyMedicalPlan,
    AgencyMedicalPlanInput,
    AgencyMedicalPlanRate,
    GpEstimatorInput,
    GpEstimatorResult,
    MedicalPlanImportResult,
} from '../app.model';

@Injectable({
    providedIn: 'root',
})
export class GpEstimatorService {
    constructor(private http: HttpClient) { }

    calculate(input: GpEstimatorInput): Observable<GpEstimatorResult> {
        return this.http.post<GpEstimatorResult>(
            `${environment.baseUrl}${apiConstant.GP_ESTIMATOR_CALCULATE}`,
            input
        );
    }

    getActivePlan(): Observable<{ plan: AgencyMedicalPlan | null }> {
        return this.http.get<{ plan: AgencyMedicalPlan | null }>(
            `${environment.baseUrl}${apiConstant.GP_MEDICAL_PLANS}/active`
        );
    }

    createPlan(payload: AgencyMedicalPlanInput): Observable<{ message: string; plan: AgencyMedicalPlan }> {
        return this.http.post<{ message: string; plan: AgencyMedicalPlan }>(
            `${environment.baseUrl}${apiConstant.GP_MEDICAL_PLANS}`,
            payload
        );
    }

    updateRate(planUuid: string, rateUuid: string, monthlyPremium: number): Observable<{ message: string; rate: AgencyMedicalPlanRate }> {
        return this.http.patch<{ message: string; rate: AgencyMedicalPlanRate }>(
            `${environment.baseUrl}${apiConstant.GP_MEDICAL_PLANS}/${planUuid}/rates/${rateUuid}`,
            { monthly_premium: monthlyPremium }
        );
    }

    importRates(uuid: string, file: File): Observable<MedicalPlanImportResult> {
        const formData = new FormData();
        formData.append('file', file);
        return this.http.post<MedicalPlanImportResult>(
            `${environment.baseUrl}${apiConstant.GP_MEDICAL_PLANS}/${uuid}/import-rates`,
            formData
        );
    }
}
